// LoginNew.js - Authentication component for user login/logout functionality
import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * LoginNew - Authentication component that displays login/logout button and user info
 * Handles user authentication state and provides login/logout functionality
 */
const LoginNew = () => {
    // Extract authentication state and methods from AuthContext
    const { user, error, isAuthenticated, handleLogout, handleLogin } = useAuth();
    // Local loading state for button feedback during auth operations
    const [isLoading, setIsLoading] = useState(false);

    /**
     * Handle login button click - initiates OAuth flow
     * Sets loading state and delegates to AuthContext handleLogin
     */
    const onLogin = async () => {
        setIsLoading(true);
        try {
            handleLogin(); // Redirects to OAuth provider
        } catch (error) {
            console.error('[LoginNew] Login failed:', error);
            setIsLoading(false);
        }
    };

    /**
     * Handle logout button click - clears session and tokens
     * Sets loading state and delegates to AuthContext handleLogout
     */
    const onLogout = async () => {
        setIsLoading(true);
        try {
            await handleLogout();
        } catch (error) {
            console.error('[LoginNew] Logout failed:', error);
        } finally {
            setIsLoading(false);
        }
    };

    if (error) {
        return (
            <div className="alert alert-danger" role="alert">
                <strong>Error:</strong> {error}
            </div>
        );
    }

    return (
        <div style={{ visibility: 'visible' }}>
            {isAuthenticated && user ? (
                <div className="d-flex align-items-center">
                    <span className="me-2">{user.name}</span>
                    <button
                        className="btn btn-secondary"
                        onClick={onLogout}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Logging out...' : 'Logout'}
                    </button>
                </div>
            ) : (
                <button
                    className="btn btn-secondary"
                    onClick={onLogin}
                    disabled={isLoading}
                >
                    {isLoading ? 'Redirecting...' : 'Login'}
                </button>
            )}
        </div>
    );
};

export default LoginNew;